import { __extends } from "tslib";
import React from 'react';
import FullscreenShareButtons from './fullscreenShareButtons.js';
import { translationUtils } from '@wix/photography-client-lib';
var FullscreenShareScreen = /** @class */ (function (_super) {
    __extends(FullscreenShareScreen, _super);
    function FullscreenShareScreen() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FullscreenShareScreen.prototype.render = function () {
        var _this = this;
        var shareButtons = (React.createElement(FullscreenShareButtons, { item: this.props.current.item, actions: {
                eventsListener: this.props.actions.eventsListener,
            } }));
        var closeShareScreen = function () {
            _this.props.actions.toggleShareScreen(false);
        };
        var shareTitleText = translationUtils
            ? translationUtils.getByKey('Gallery_Fullscreen_Mobile_Share')
            : 'Share';
        var showShareScreen = this.props.showShareScreen;
        return (React.createElement("div", { className: 'fullscreen-share-screen' +
                (showShareScreen ? '' : ' pro-fullscreen-closed') },
            React.createElement("div", { className: 'fullscreen-share-screen-background' +
                    (showShareScreen ? '' : ' pro-fullscreen-closed'), onClick: showShareScreen ? closeShareScreen : null }),
            React.createElement("div", { className: 'fullscreen-share-screen-tab' +
                    (showShareScreen ? '' : ' pro-fullscreen-closed') },
                showShareScreen && (React.createElement("div", { className: 'fullscreen-share-screen-tab-title' }, shareTitleText)),
                showShareScreen && shareButtons)));
    };
    return FullscreenShareScreen;
}(React.Component));
export default FullscreenShareScreen;
//# sourceMappingURL=fullscreenShareScreen.js.map